var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUkuleleBaritone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4262 4582 c-191 -217 -200 -229 -206 -278 -4 -28 -17 -67 -29 -86 -12 -19 -372 -371 -799 -781 l-778 -746 -67 51 c-190 144 -407 166 -559 56 -60 -43 -117 -120 -195 -264 -125 -231 -222 -292 -603 -383 -304 -73 -566 -304 -641 -565 -46 -157 23 -395 168 -586 63 -83 300 -323 403 -409 121 -100 185 -138 307 -179 129 -43 236 -52 323 -27 261 75 492 337 565 641 45 188 71 270 112 348 58 113 125 176 271 255 65 35 144 83 175 107 131 99 182 237 147 402 -20 95 -51 161 -114 245 l-51 67 746 778 c410 427 762 787 781 799 19 12 58 25 86 29 49 6 61 15 278 206 l227 199 -35 77 c-25 56 -52 94 -97 139 -45 45 -83 72 -139 97 l-77 35 -199 -227z m-2102 -2283 c179 -81 217 -320 72 -451 -73 -66 -154 -87 -245 -63 -110 28 -174 92 -202 202 -33 125 30 253 150 309 66 31 161 32 225 3z m-748 -886 c148 -148 268 -271 268 -275 0 -4 -25 -24 -56 -44 l-57 -36 -26 21 c-14 11 -69 42 -121 68 -130 65 -208 143 -273 273 -26 52 -57 107 -68 121 l-21 26 36 57 c20 31 40 56 44 56 4 0 127 -120 274 -267z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4185 4706 c-30 -30 -32 -66 -6 -90 18 -16 22 -16 49 -2 35 18 60 71 45 95 -17 27 -59 25 -88 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4016 4518 c-36 -32 -42 -69 -16 -93 19 -17 22 -18 54 -2 45 21 69 83 40 104 -26 19 -49 16 -78 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4649 4265 c-14 -7 -31 -26 -37 -41 -26 -56 46 -87 93 -39 27 26 32 64 13 83 -15 15 -37 15 -69 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4464 4096 c-18 -8 -36 -27 -44 -46 -12 -28 -11 -33 7 -52 17 -17 26 -19 49 -11 43 14 70 57 58 90 -11 33 -28 37 -70 19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUkuleleBaritone);
export default __webpack_public_path__ + "static/media/icon_ukulele-baritone.4ea9b18c.svg";
export { ForwardRef as ReactComponent };